module.exports = __webpack_public_path__ + "img/placeholder/ChAuj-author-picture.jpg";